export default new class ImageRender {

  /**
   *
   * @param def
   * @param rowData
   * @return {string}
   */
  render (def, rowData) {
    let string = ''
    def.forEach((item) => {
      let data = JSON.parse(rowData[item.ColumnName])

      string = string + '<span class="' + data.ImageClass + '">'
      string = string + '<img src="' + data.Value + '">'

      return string + '</span>'
    })

    return string
  }

}